import { useQuery } from '@tanstack/react-query';
import { CustomQueryOptions } from '../common.types';
import { ProjectService } from '../../generated';

export const useManifest = (options: CustomQueryOptions<any> = {}) => {
    return useQuery({
        queryKey: ['manifest'],
        queryFn: async () => {
            const response = await ProjectService.getManifest({});

            if (!response.data) throw new Error('Failed');

            return response.data;
        },
        retry: false,
        cacheTime: 10,
        ...options,
    });
};
